import {WorkflowOption, WorkflowType} from "./types";

export const WORKFLOW_OPTIONS: Record<WorkflowType, WorkflowOption> = {
  [WorkflowType.ADMISSION]: {
    type: WorkflowType.ADMISSION,
    label: "Admission",
  },
  [WorkflowType.ADMISSION_CONTRACT]: {
    type: WorkflowType.ADMISSION_CONTRACT,
    label: "Admission Contract",
  },
  [WorkflowType.READMISSION]: {
    type: WorkflowType.READMISSION,
    label: "Re-Admission",
  },
  [WorkflowType.CONSENTS]: {
    type: WorkflowType.CONSENTS,
    label: "Consents",
  },
  [WorkflowType.ARBITRATION]: {
    type: WorkflowType.ARBITRATION,
    label: "Arbitration",
  },
  [WorkflowType.DISPUTE_RESOLUTIONS]: {
    type: WorkflowType.DISPUTE_RESOLUTIONS,
    label: "Dispute Resolutions",
  },
  [WorkflowType.PRE_ADMISSION_DOCUMENTS]: {
    type: WorkflowType.PRE_ADMISSION_DOCUMENTS,
    label: "Pre-Admission Documents",
  },
  [WorkflowType.POST_ADMISSION_DOCUMENTS]: {
    type: WorkflowType.POST_ADMISSION_DOCUMENTS,
    label: "Post-Admission Documents",
  },
  [WorkflowType.FINANCIAL_FORMS]: {
    type: WorkflowType.FINANCIAL_FORMS,
    label: "Financial Forms",
  },
  [WorkflowType.CLINICAL_FORMS]: {
    type: WorkflowType.CLINICAL_FORMS,
    label: "Clinical Forms",
  },
};

/** Static labels for known workflow types; facility-specific lists come from WorkflowService. */
